<template>
    <BaseInputSelect
        v-bind="$attrs"
        v-on="$listeners"
        :items="timezones"
        item-text="text" 
        item-value="utc[0]"
    />
</template>

<script>
import BaseInputSelect from "./BaseInputSelect";
import timezonesList from "../../../assets/timezones.json";

export default {
    name: "TimeZoneInput",
    components: {BaseInputSelect},
    inheritAttrs: false,
    data() {
        return {
            timezones: timezonesList,
        }
    },
}
</script>